import { TESTIDS } from "@/constants/testIds";
import { LABEL_LOOKUP, LOCATION_OPTIONS, DEVICE_OPTIONS, KIND_OPTIONS, LEVEL_STYLES } from "@/lib/enums";
import { Trash2 } from "lucide-react";
import { t } from "@/lib/i18n";

const ReadingHistory = ({ readings, onDelete }) => {
  return (
    <div className="card-flat" data-testid={TESTIDS.historyList}>
      <div className="flex items-baseline justify-between">
        <h3 className="font-serif text-xl text-[#1C201F]">{t("Testing history")}</h3>
        {readings.length > 0 && (
          <span className="text-xs text-[#5C6661]">
            {readings.length} {t(readings.length === 1 ? "reading" : "readings")}
          </span>
        )}
      </div>
      {readings.length === 0 ? (
        <p className="text-sm text-[#5C6661] mt-3">
          {t("Every radon test you enter will be saved here — a permanent record for this property.")}
        </p>
      ) : (
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] tracking-[0.18em] uppercase text-[#5C6661] border-b border-[#E8ECEA]">
                <th className="py-2 pr-3 font-semibold">{t("Date")}</th>
                <th className="py-2 pr-3 font-semibold">{t("Location")}</th>
                <th className="py-2 pr-3 font-semibold">{t("Reading")}</th>
                <th className="py-2 pr-3 font-semibold">{t("Device")}</th>
                <th className="py-2 pr-3 font-semibold">{t("Kind")}</th>
                <th className="py-2 pr-0 font-semibold text-right"> </th>
              </tr>
            </thead>
            <tbody>
              {readings.map((r) => {
                const style = LEVEL_STYLES[r.classification?.level] || {};
                return (
                  <tr
                    key={r.id}
                    className="border-b border-[#E8ECEA]/60 hover:bg-[#FAFAFA] transition-colors"
                    data-testid={TESTIDS.historyItem}
                    data-reading-id={r.id}
                  >
                    <td className="py-3 pr-3 text-[#1C201F]">{r.reading_date}</td>
                    <td className="py-3 pr-3 text-[#5C6661]">
                      {LABEL_LOOKUP(LOCATION_OPTIONS, r.location_in_home)}
                    </td>
                    <td className="py-3 pr-3">
                      <span className="inline-flex items-center gap-2">
                        <span
                          className="w-2 h-2 rounded-full"
                          style={{ background: style.border || "#C8CFCB" }}
                        />
                        <span className="font-serif text-base text-[#1C201F]">
                          {r.pci_l.toFixed(1)}
                        </span>
                        <span className="text-[10px] text-[#5C6661]">{t("pCi/L")}</span>
                      </span>
                    </td>
                    <td className="py-3 pr-3 text-[#5C6661]">
                      {LABEL_LOOKUP(DEVICE_OPTIONS, r.device_type)}
                    </td>
                    <td className="py-3 pr-3 text-[#5C6661]">
                      {LABEL_LOOKUP(KIND_OPTIONS, r.kind)}
                    </td>
                    <td className="py-3 pr-0 text-right">
                      <button
                        onClick={() => onDelete(r.id)}
                        className="text-[#5C6661] hover:text-[#9B2C2C] transition-colors p-1"
                        aria-label={t("Delete reading")}
                        data-testid="reading-delete-button"
                      >
                        <Trash2 size={14} />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ReadingHistory;
